import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Home, Users, FileText, MailOpen, TrendingUp, ArrowUpRight } from 'lucide-react';
import api from '../../lib/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState({ properties: 0, agents: 0, blog: 0, inquiries: 0, recent: [] });

  useEffect(() => {
    Promise.all([
      api.get('/admin/properties'),
      api.get('/admin/agents'),
      api.get('/admin/blog'),
      api.get('/admin/inquiries'),
    ]).then(([p, a, b, i]) => {
      setStats({
        properties: p.data.length,
        agents: a.data.length,
        blog: b.data.length,
        inquiries: i.data.length,
        recent: i.data.slice(0, 5),
        recentProps: p.data.slice(0, 5),
      });
    }).catch(() => {});
  }, []);

  const cards = [
    { label: 'Properties', value: stats.properties, icon: Home, to: '/admin/properties', color: 'bg-blue-50 text-blue-700' },
    { label: 'Advisors', value: stats.agents, icon: Users, to: '/admin/agents', color: 'bg-purple-50 text-purple-700' },
    { label: 'Blog Posts', value: stats.blog, icon: FileText, to: '/admin/blog', color: 'bg-amber-50 text-amber-700' },
    { label: 'Inquiries', value: stats.inquiries, icon: MailOpen, to: '/admin/inquiries', color: 'bg-red-50 text-[#DC2626]' },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-neutral-900">Dashboard</h1>
          <p className="text-sm text-neutral-500">Overview of your Terra Homes Realty site</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <Link key={c.label} to={c.to} className="bg-white p-5 rounded-xl border border-neutral-200 hover:shadow-md transition-shadow group">
              <div className="flex items-start justify-between">
                <div className={'inline-flex w-11 h-11 rounded-lg items-center justify-center ' + c.color}>
                  <Icon className="w-5 h-5" />
                </div>
                <ArrowUpRight className="w-4 h-4 text-neutral-400 group-hover:text-[#DC2626]" />
              </div>
              <p className="mt-4 text-3xl font-bold text-neutral-900">{c.value}</p>
              <p className="text-sm text-neutral-500">{c.label}</p>
            </Link>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <div className="bg-white p-5 rounded-xl border border-neutral-200">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-bold text-neutral-900">Recent Inquiries</h3>
            <Link to="/admin/inquiries" className="text-xs text-[#DC2626] font-medium">View All</Link>
          </div>
          {!stats.recent?.length ? <p className="text-sm text-neutral-500">No inquiries yet.</p> : (
            <ul className="divide-y divide-neutral-100">
              {stats.recent.map((q) => (
                <li key={q.id} className="py-3">
                  <p className="font-medium text-neutral-900 text-sm">{q.name}</p>
                  <p className="text-xs text-neutral-500">{q.email} · {q.subject}</p>
                  <p className="text-sm text-neutral-600 mt-1 line-clamp-1">{q.message}</p>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="bg-white p-5 rounded-xl border border-neutral-200">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-bold text-neutral-900">Recent Properties</h3>
            <Link to="/admin/properties" className="text-xs text-[#DC2626] font-medium">View All</Link>
          </div>
          {!stats.recentProps?.length ? <p className="text-sm text-neutral-500">No properties yet.</p> : (
            <ul className="divide-y divide-neutral-100">
              {stats.recentProps.map((p) => (
                <li key={p.id} className="py-3 flex justify-between">
                  <div>
                    <p className="font-medium text-neutral-900 text-sm">{p.title}</p>
                    <p className="text-xs text-neutral-500">{p.type} · {p.location}</p>
                  </div>
                  <span className="text-sm font-semibold text-[#DC2626]">{p.price_label}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
